// extracted by mini-css-extract-plugin
module.exports = {"cardsContainer":"CardsContainer_cardsContainer__2RuC8","form__submit":"CardsContainer_form__submit__3z2tZ","loading":"CardsContainer_loading__3ZXF0"};